import Work from "../../assets/work.jpg";

export const projectsData = [
  {
    id: 1,
    image: Work,
    title: "chat-app",
    category: "web",
    url: "https://bit2-chat-app.web.app/",
  },
  {
    id: 2,
    image: Work,
    title: "food-app",
    category: "web",
    url: "https://food-app-frontend-nmtp-mp2951cas-arghyadeb11.vercel.app/",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
  {
    name: "design",
  },
];
